<script lang="ts">
  const { children } = $props();
</script>

<div>
  {@render children()}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  div {
    font-family: "OttoSansMedium", sans-serif;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: bold;
    padding-bottom: tokens.$oc-semantic-spacing-100;
  }
</style>
